/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormStateSchema,
} from '@gh/builder-shared';
import { FormState } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { BaseDesignDetails } from '@gh/builder-shared-data';

@Injectable()
export class BaseDesignDetailsFormState extends FormState<BaseDesignDetails> {

  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }
  protected buildSchema(_: BaseDesignDetails, { root, group }: FormStateSchema): FormRootSchema {
    return root({
      mode: FormMode.ViewMode,
      enabled: false,
      optimisticLock: true,
      children: {
        parentDesign: void 0,
        designSeriesName:  void 0,
        name:  void 0,
        storeys:  void 0,
        bedrooms:  void 0,
        bathrooms:  void 0,
        carSpaces:  void 0,
        floorArea:  group({
          children: {
            value: void 0,
            unit: void 0,
          },
        }),
        description:  void 0,
        additionalFeatures:  void 0,
      },
    });
  }
}
